import { useTheme } from "@mui/material";
import { View, Text } from "@react-pdf/renderer";
import { isEmpty } from "lodash";
import { PDFStyleConfigs } from "../../configs";
import { HorizontalLine } from "../horizontal-line";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";

export const PDFTitle = ({
  title,
  subTitle,
}: {
  title?: string;
  subTitle?: string;
}) => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const { palette } = useTheme();

  return (
    <View
      style={{
        height: !isEmpty(subTitle)
          ? PDFStyleConfigs.SubTitleHeight
          : PDFStyleConfigs.TitleHeight,
      }}
    >
      <Text
        style={{
          ...typographyStyle.title,
          color: palette.common.black,
          fontSize: "14px",
          textAlign: "left",
        }}
      >
        {title}
      </Text>
      <HorizontalLine color={palette.common.black} />
      {!isEmpty(subTitle) && (
        <Text
          style={{
            ...typographyStyle.subtitle,
            color: palette.common.black,
            textAlign: "left",
          }}
        >
          {subTitle}
        </Text>
      )}
    </View>
  );
};
